import {
  getPartialInitialOrganizationList,
  getPartialInitialAccountList,
  getPartialInitialContactList,
  getPartialQueryOrganizationList,
  getPartialQueryAccountList,
  getPartialQueryContactList,
} from '../../routines';
import { populateEntityOptions } from '../../../common/util/EntityUtils';

const initialState = {
  list: {
    initialOrganizations: [],
    initialAccounts: [],
    initialContacts: [],
    organizations: [],
    accounts: [],
    contacts: [],
  },
  initialLoading: false,
  queryLoading: false,
  error: null,
};

const partialInitialEntityListReducer = (state = initialState, action) => {
  switch (action.type) {
    case getPartialInitialOrganizationList.TRIGGER:
    case getPartialInitialAccountList.TRIGGER:
    case getPartialInitialContactList.TRIGGER: {
      return {
        ...state,
        initialLoading: true,
        error: null,
      };
    }
    case getPartialQueryOrganizationList.TRIGGER:
    case getPartialQueryAccountList.TRIGGER:
    case getPartialQueryContactList.TRIGGER: {
      return {
        ...state,
        list: {
          ...state.list,
          organizations: [],
          accounts: [],
          contacts: [],
        },
        queryLoading: true,
        error: null,
      };
    }
    case getPartialInitialOrganizationList.SUCCESS: {
      return {
        ...state,
        initialLoading: false,
        error: null,
        list: {
          ...state.list,
          initialOrganizations: populateEntityOptions(action.payload.data),
        },
      };
    }
    case getPartialInitialAccountList.SUCCESS: {
      return {
        ...state,
        initialLoading: false,
        error: null,
        list: {
          ...state.list,
          initialAccounts: populateEntityOptions(action.payload.data),
        },
      };
    }
    case getPartialInitialContactList.SUCCESS: {
      return {
        ...state,
        initialLoading: false,
        error: null,
        list: {
          ...state.list,
          initialContacts: populateEntityOptions(action.payload.data),
        },
      };
    }
    case getPartialQueryOrganizationList.SUCCESS: {
      return {
        ...state,
        queryLoading: false,
        error: null,
        list: {
          ...state.list,
          organizations: populateEntityOptions(action.payload.data),
        },
      };
    }
    case getPartialQueryAccountList.SUCCESS: {
      return {
        ...state,
        queryLoading: false,
        error: null,
        list: {
          ...state.list,
          accounts: populateEntityOptions(action.payload.data),
        },
      };
    }
    case getPartialQueryContactList.SUCCESS: {
      return {
        ...state,
        queryLoading: false,
        error: null,
        list: {
          ...state.list,
          contacts: populateEntityOptions(action.payload.data),
        },
      };
    }
    case getPartialInitialOrganizationList.FAILURE:
    case getPartialInitialAccountList.FAILURE:
    case getPartialInitialContactList.FAILURE: {
      return {
        ...state,
        initialLoading: false,
        error: action.payload.error,
      };
    }
    default: {
      return state;
    }
  }
};

export default partialInitialEntityListReducer;
